export enum TransactionOption {
  SUCCESS = 1,
  PROCESSING = 2,
  TIMEOUT = 3,
  ERROR = 4,
}

export const TransactionOptionName = Object.freeze({
  [TransactionOption.SUCCESS]: "Thành công",
  [TransactionOption.PROCESSING]: "Chờ xử lý",
  [TransactionOption.TIMEOUT]: "Hết thời gian",
  [TransactionOption.ERROR]: "Báo lỗi",
});

